import { render, staticRenderFns } from "./SPIFRatios.vue?vue&type=template&id=94c79610"
import script from "./SPIFRatios.vue?vue&type=script&lang=js"
export * from "./SPIFRatios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports